// @mui material components
import Card from "@mui/material/Card";
// import Divider from "@mui/material/Divider";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
// import MDButton from "components/MDButton";
import CategoryIcon from "@mui/icons-material/Category";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";

// Billing page components
import Transaction from "layouts/receitaXdespesa/components/Transaction";
import { useEffect, useMemo, useState } from "react";
import { getRevenueExpensesList } from "../receitasxdespesas/revenueExpensesApi";
import { Autocomplete, CircularProgress, InputAdornment, Pagination, TextField } from "@mui/material";
import KeepMountedModal from "components/Modal";
import AddNewRevenueExpenseForm from "../receitasxdespesas/addNewRevenueExpenseForm";
import styled, { css } from "styled-components";
import SearchInput from "components/SearchInput";
import DateRangePicker from "components/DateRangePicker";
import { useDebounce } from "use-lodash-debounce";
import {
  formatRevenueExpenseCategory,
  getRevenueExpenseCategoryOptions,
} from "../receitasxdespesas/revenueExpenseCategories";
import { HIDDEN_CURRENCY_LABEL } from "utils/valueVisibility";
import { useMaterialUIController } from "context";
import colors from "assets/theme/base/colors";
import MDButton from "components/MDButton";
import RevenueExpenseExportDialog from "./RevenueExpenseExportDialog";

function Transactions(props) {
  const { openSnackBar, hasNewTransaction, refreshSummaryBoxes, valuesHidden } = props;
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [reloadTransactionList, setReloadTransactionList] = useState(false);

  const [revenuesXExpensesList, setRevenuesXExpensesList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [id, setId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(null);
  const [search, setSearch] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('');
  const [dateRange, setDateRange] = useState({});
  const [okButtonClickd, setOkButtonClickd] = useState(false);
  const [reloadList, setReloadList] = useState(false);
  const [openExportDialog, setOpenExportDialog] = useState(false);

  const categoryOptions = useMemo(() => getRevenueExpenseCategoryOptions(), []);
  const debouncedSearch = useDebounce(search, 500);
  const debouncedCategoryFilter = useDebounce(categoryFilter, 500);

  useEffect(() => {
    if (hasNewTransaction != undefined) {
      getRevenuesXExpensesListMethod();
    }
  }, [])

  useEffect(() => {
    if (hasNewTransaction || reloadTransactionList) {
      getRevenuesXExpensesListMethod();
    }
  }, [reloadTransactionList, hasNewTransaction, currentPage, debouncedSearch, debouncedCategoryFilter, dateRange])


  useEffect(() => {

    if (revenuesXExpensesList?.length == 0) {
      setCurrentPage(1);
    }
  }, [revenuesXExpensesList?.length]);

  const getRevenuesXExpensesListMethod = async () => {
    setIsLoading(true);

    await getRevenueExpensesList(debouncedSearch, debouncedCategoryFilter, dateRange?.startDate, dateRange?.endDate, 10, currentPage)
      .then((data) => {
        setTotalPages(data.pageCount);

        let groupedByMakeDate = data.results.reduce((acc, item) => {
          const date = item.makeDateString;

          // Se a data ainda não existe no acumulador, inicialize um array para ela
          if (!acc[date]) {
            acc[date] = [];
          }

          // Adicione o item ao array correspondente à data
          acc[date].push(item);

          return acc;
        }, {});

        const groupedArray = Object.entries(groupedByMakeDate).map(([makeDate, items]) => ({
          makeDate,
          items
        }));

        setRevenuesXExpensesList(groupedArray);
      })

    console.log(revenuesXExpensesList.length)

    setIsLoading(false);
  }

  const handleOpenModal = (id) => {
    setId(id);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSearchChange = (search) => {
    setSearch(search);
    setCurrentPage(1);
  }

  const handleDateRangeChange = (nextDateRange) => {
    setDateRange(nextDateRange);
    setCurrentPage(1);
  };

  const handleCategoryFilterChange = (nextValue) => {
    const nextCategory = typeof nextValue === "string" ? nextValue : nextValue?.value ?? "";
    setCategoryFilter(nextCategory);
    setCurrentPage(1);
  };

  return (
    <>
      <Card sx={{ height: "100%" }}>
        <MDBox pt={3} px={2}>
          <StyledHeaderRow>
            <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
              Extrato
            </MDTypography>
            <MDButton
              variant="gradient"
              color="info"
              size="small"
              onClick={() => setOpenExportDialog(true)}
              sx={{ width: { xs: "100%", sm: "auto" }, minWidth: { sm: 170 }, gap: 0.75 }}
            >
              <DownloadOutlinedIcon fontSize="small" />
              Exportar
            </MDButton>
          </StyledHeaderRow>
          <StyledFiltersGrid>
            <StyledFilterControl className="search-input-div">
              <SearchInput handleSearchChange={(e) => handleSearchChange(e)} />
            </StyledFilterControl>
            <StyledCategoryFilter className="category-input-div">
              <Autocomplete
                freeSolo
                options={categoryOptions}
                sx={{ width: "100%" }}
                componentsProps={{
                  paper: {
                    sx: {
                      minWidth: 260,
                      maxHeight: 320,
                    },
                  },
                }}
                value={categoryFilter || null}
                isOptionEqualToValue={(option, value) => {
                  if (typeof value === "string") {
                    return option.value === value;
                  }

                  return option.value === value?.value;
                }}
                getOptionLabel={(option) => {
                  if (typeof option === "string") {
                    return formatRevenueExpenseCategory(option);
                  }

                  return formatRevenueExpenseCategory(option.value);
                }}
                onChange={(_, newValue) => handleCategoryFilterChange(newValue)}
                onInputChange={(_, newInputValue, reason) => {
                  if (reason === "input" || reason === "clear") {
                    handleCategoryFilterChange(newInputValue);
                  }
                }}
                renderOption={(props, option) => (
                  <li {...props} key={option.value} title={formatRevenueExpenseCategory(option.value)}>
                    <StyledCategoryOption>
                      {formatRevenueExpenseCategory(option.value)}
                    </StyledCategoryOption>
                  </li>
                )}
                renderInput={(params) => (
                  <StyledCategoryTextField
                    {...params}
                    $isDarkTheme={darkMode}
                    variant="standard"
                    placeholder="Categoria"
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <>
                          <InputAdornment position="start">
                            <StyledCategoryIcon $isDarkTheme={darkMode} />
                          </InputAdornment>
                          {params.InputProps.startAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </StyledCategoryFilter>
            <StyledFilterControl className="calendar-input-div" color="text" lineHeight={0}>
              <DateRangePicker setDateRange={handleDateRangeChange}
                okButtonClicked={() => setOkButtonClickd(!okButtonClickd)}
                resetValues={() => setReloadList(!reloadList)}
              />
            </StyledFilterControl>
          </StyledFiltersGrid>
        </MDBox>
        <MDBox pt={3} pb={2} px={2}>
          {isLoading
            ? <CircularProgress color="inherit" size={16} />
            :
            <>
              {revenuesXExpensesList?.map(e => {
                return (<div key={e.id}>
                  <MDBox mb={2}>
                    <MDTypography variant="caption" color="text" fontWeight="bold" textTransform="uppercase">
                      {e.makeDate}
                    </MDTypography>
                  </MDBox>
                  <MDBox
                    component="ul"
                    display="flex"
                    flexDirection="column"
                    p={0}
                    m={0}
                    sx={{ listStyle: "none" }}
                  >
                    {e.items?.map(e => {
                      return (
                        <Transaction
                          color={e.type == 1 ? "success" : "error"}
                          icon={e.type == 1 ? "expand_less" : "expand_more"}
                          name={e.name}
                          description={e.category ? `${formatRevenueExpenseCategory(e.category)} • ${e.makeDateString}` : e.makeDateString}
                          value={valuesHidden ? HIDDEN_CURRENCY_LABEL : `R$ ${e.type == 1 ? e.value : '-' + e.value}`}
                          id={e.id}
                          onOpenEditModal={(id) => handleOpenModal(id)}
                        />
                      )
                    })}

                  </MDBox>

                </div>)
              })}


            </>
          }
          {totalPages > 1 && (
            <StyledPagination
              sx={{ display: 'flex', justifyContent: 'center', paddingTop: 4 }}
              disabled={isLoading}
              count={totalPages}
              boundaryCount={1}
              onChange={(e, page) => setCurrentPage(page)}
              size="small"
              currentPage={2}
            />
          )}

        </MDBox>

        <KeepMountedModal
          title="Editar receita ou despesa"
          content={<AddNewRevenueExpenseForm
            openSnackBar={(e) => openSnackBar(e)}
            title="Editar receita ou despesa"
            id={id}
            closeModal={handleCloseModal}
            refreshList={() => setReloadTransactionList(!reloadTransactionList)}
            refreshSummaryBoxes={refreshSummaryBoxes}
          />}
          closeModal={handleCloseModal} // Passa o setter diretamente
          isOpen={openModal} // Passa o estado diretamente
        />
        <RevenueExpenseExportDialog
          open={openExportDialog}
          onClose={() => setOpenExportDialog(false)}
          openSnackBar={openSnackBar}
          search={debouncedSearch}
          category={debouncedCategoryFilter}
          initialStartDate={dateRange?.startDate}
          initialEndDate={dateRange?.endDate}
        />
      </Card>
    </>
  );
}

const StyledPagination = styled(Pagination)`
    .MuiPagination-ul button{
        background: radial-gradient(circle at 225% 577%, #f28371 0%, #f28371 84%, transparent 0%),#F0BA8E!important;
        opacity: 0.8; 

        &[disabled]{
            opacity: 0.4; 
        }

        &.Mui-selected {
            opacity: 0.9; 
            background: radial-gradient(circle at -136% 568%, #f28371 0%, #f28371 98%, transparent 0%),#F0BA8E!important
        }
    }

    .MuiPagination-ul li{
        padding: 0 2px;
    }
`;

const StyledFiltersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(160px, 1fr));
  gap: 16px;
  align-items: end;
  width: 100%;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const StyledHeaderRow = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;

  @media (max-width: 600px) {
    align-items: stretch;
    flex-direction: column;
  }
`;

const StyledFilterControl = styled(MDBox)`
  min-width: 0;
  width: 100%;

  .MuiFormControl-root,
  .MuiInputBase-root,
  .mother,
  .mother > div,
  .rmdp-container {
    width: 100%;
  }

  .MuiInputBase-root,
  .rmdp-input {
    min-height: 32px;
  }

  .rmdp-input {
    box-sizing: border-box;
    margin: 0;
    width: 100%;
  }

  .icon-tabler-calendar-event {
    left: 3px;
  }
`;

const StyledCategoryTextField = styled(TextField)`
  width: 100%;

  .MuiInputBase-root {
    color: ${({ $isDarkTheme }) => ($isDarkTheme ? "rgba(255, 255, 255, 0.8)" : colors.grey[700])};
    min-height: 32px;
  }

  .MuiInput-underline:before {
    border-bottom-color: ${({ $isDarkTheme }) => ($isDarkTheme ? "#8b909d" : colors.inputBorderColor)} !important;
  }

  .MuiInput-underline:hover:not(.Mui-disabled):before {
    border-bottom-color: ${({ $isDarkTheme }) => ($isDarkTheme ? "rgba(255, 255, 255, 0.8)" : colors.inputBorderColor)} !important;
  }

  .MuiInput-underline:after {
    border-bottom-color: ${colors.info.main};
  }

  input::placeholder {
    color: ${({ $isDarkTheme }) => ($isDarkTheme ? "rgba(255, 255, 255, 0.55)" : colors.grey[500])};
    opacity: 1;
  }

`;

const StyledCategoryFilter = styled(MDBox)`
  min-width: 0;
  width: 100%;

  .MuiAutocomplete-root {
    width: 100%;
  }

  .MuiAutocomplete-inputRoot {
    flex-wrap: nowrap;
  }

  .MuiAutocomplete-input {
    min-width: 0 !important;
  }
`;

const StyledCategoryOption = styled.span`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;

const StyledCategoryIcon = styled(CategoryIcon)`
  ${({ $isDarkTheme }) =>
    css`
      fill: ${$isDarkTheme ? "rgba(255, 255, 255, 0.8)" : colors.grey[500]} !important;
    `}
`;

export default Transactions;
